import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'admin',
    redirect: '/home',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: {
      requiresAuth: false,
      title: '工商&機構&團體管理',
      permissions: ['Administrator', 'AppProvider', 'AppUser', 'Reviewer'],
    },
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('../views/Home/HomePage.vue'),
        meta: { requiresAuth: false, title: '代表人管理' },
      },
    ],
  },

  {
    path: '/sdk',
    name: 'Sdk',
    redirect: '/sdk/manage',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: {
      requiresAuth: false,
      title: '長照SDK服務',
      permissions: ['Administrator', 'Reviewer', 'AppProvider', 'AppUser'],
    },
    children: [
      {
        path: 'manage',
        name: 'SdkManagePage',
        component: () => import('../views/Sdk/SdkManagePage.vue'),
        meta: { requiresAuth: false, title: 'SDK 申請/審核' },
      },
      {
        path: 'key-manage',
        name: 'KeyManagePage',
        component: () => import('../views/Sdk/KeyManagePage.vue'),
        meta: { permissions: ['Administrator'], requiresAuth: false, title: '金鑰管理' },
      },
      {
        path: 'info/:organization?/:id?',
        name: 'SdkInfoPage',
        component: () => import('../views/Sdk/SdkManagement.vue'),
        meta: {
          requiresAuth: false,
          title: 'SDK 現況管理',
          hiddenMenu: true,
          parent: 'SdkManagePage',
        },
      },
    ],
  },
  {
    path: '/manage',
    name: 'Manage',
    redirect: '/manage/service',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: {
      requiresAuth: false,
      title: '系統管理',
      permissions: ['Administrator', 'AppProvider'],
    },
    children: [
      {
        path: 'service',
        name: 'Service',
        component: () => import('../views/Manage/ManagePage.vue'),
        meta: {
          requiresAuth: false,
          title: '帳號資料管理',
          permissions: ['Administrator', 'AppProvider'],
        },
      },
      {
        path: 'unit',
        name: 'Unit',
        component: () => import('../views/Manage/UnitManagePage.vue'),
        meta: {
          requiresAuth: false,
          title: '單位管理',
        },
      },
      {
        path: 'unit/user',
        name: 'UnitUser',
        component: () => import('../views/Manage/UserList.vue'),
        meta: {
          requiresAuth: false,
          title: '用戶清單',
          hiddenMenu: true,
          parent: 'Unit',
        },
      },
      {
        path: 'ManageLogin',
        name: 'ManageLogin',
        component: () => import('../views/Manage/LoginManagePage.vue'),
        meta: { requiresAuth: false, title: '登入登出紀錄查詢' },
      },
      {
        path: 'news',
        name: 'News',
        component: () => import('../views/Manage/NewsManagePage.vue'),
        meta: { requiresAuth: false, title: '公告管理' },
      },
      {
        path: 'appreqjwtlog',
        name: 'AppReqJWTLog',
        component: () => import('../views/Manage/AppReqJWTLogPage.vue'),
        meta: { requiresAuth: false, title: 'AppReqJWT Log' },
      },
      {
        path: 'appgetdatalog',
        name: 'AppGetDataLog',
        component: () => import('../views/Manage/AppGetDataLogPage.vue'),
        meta: { requiresAuth: false, title: 'AppGetData Log' },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Auth/UserLogin.vue'),
    meta: { hiddenMenu: true },
  },
  {
    path: '/admin-login',
    name: 'AdminLogin',
    component: () => import('../views/Auth/AdminLogin.vue'),
    meta: { hiddenMenu: true },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Auth/UserRegister.vue'),
    meta: { hiddenMenu: true },
  },
  {
    path: '/bind',
    name: 'BindPage',
    component: () => import('../views/BindPage.vue'),
    meta: { hiddenMenu: true, requiresAuth: true, title: '綁定機構資料' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound/NotFoundPage.vue'),
    meta: { hiddenMenu: true },
  },
];

// 創建路由實例
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'), // 基於環境變數
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('auth'); // 檢查登入狀態
  // const isBound = localStorage.getItem('isBound') === 'true'; // 檢查是否綁定完成
  const userPermissions = localStorage.getItem('permissions') || ''; // 從 localStorage 取得用戶權限

  if (!isAuthenticated && to.name !== 'Login' && to.name !== 'AdminLogin' && to.name !== 'Register') {
    // 未登入，跳轉至登入頁
    next({ name: 'Login' });
  }
  // else if (isAuthenticated && !isBound && to.name !== 'BindPage') {
  //   // 已登入但未綁定，跳轉至綁定頁
  //   next({ name: 'BindPage' });
  // }
  else if (
    to.meta.permissions &&
    !to.meta.permissions.includes(userPermissions)
  ) {
    // 權限不足，跳轉至404
    next({ name: 'NotFound' });
  } else {
    // 放行
    next();
  }
});

export default router;
